import QuestionForm from "@/components/Questions/QuestionForm"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/questions/$questionId/edit")({
  component: EditQuestion,
})

function EditQuestion() {
  const { questionId } = Route.useParams()
  return <QuestionForm mode="edit" questionId={questionId} />
}
